module.exports = __webpack_public_path__ + "static/media/client6.81571497.jpg";